import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InfoOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import TooltipBase from '../TooltipBase';
import ROUTES from '../../../Configs/routes';
import { getUserData } from '../../../Utils/storages';
import Info from '../Info';

export default function Component(props) {
  const { classes } = props;
  const navigate = useNavigate();
  const user = getUserData();
  const { t } = useTranslation();

  const quota = user.quota || 0;
  const totalQuota = user.total_quota || 0;
  const usedQuota = totalQuota - quota;

  return (
    <Box
      {...props}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      className={classes.root}
    >
      <Box display="flex" gap={1} alignItems="center" color="#fff" className="s-14 weight-600">
        <Box position="relative" alignSelf="center" display="inline-flex">
          <CircularProgress
            className="bg-progress"
            variant="determinate"
            value={100}
            size={32}
            thickness={5}
          />
          <CircularProgress
            className={!quota ? 'red-progress' : 'green-progress'}
            variant="determinate"
            value={(usedQuota / totalQuota) * 100}
            size={32}
            thickness={5}
            sx={{ position: 'absolute', left: 0 }}
          />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            fontSize={8}
            color={!quota ? '#FD6969' : '#38AC3D'}
            fontWeight="700"
          >
            {Math.ceil((usedQuota / totalQuota) * 100) || 100}
            %
          </Box>
        </Box>
        <Box>
          <Box fontSize={10} color="#ABB1BB">{t('myStoragesPage.availStorage')}</Box>
          <Box fontSize={12} color="#2E3C40" fontWeight="700">
            {usedQuota}
            {' '}
            {t('myStoragesPage.used')}
            {' '}
            /
            {' '}
            {totalQuota}
            {' '}
            {t('myStoragesPage.total')}
          </Box>
        </Box>
      </Box>
      {quota
        ? (
          <TooltipBase
            onClick={() => navigate(ROUTES.extraStorage())}
            icon={<InfoOutlined className="black" fontSize="small" />}
          />
        ) : (
          <Info
            alignItems="center"
            message={user.subscription ? (
              <Box onClick={() => navigate(ROUTES.extraStorage())}>
                <Box fontSize={10} fontWeight="600">Out of storage?</Box>
                <Box fontSize={10} fontWeight="700" color="#004C3B">Upgrade here</Box>
              </Box>
            ) : (
              <Box onClick={() => navigate(ROUTES.subscription())}>
                <Box fontSize={10} fontWeight="600">Unlock 6 storage spaces</Box>
                <Box fontSize={10} fontWeight="700" color="#004C3B">Subscribe now</Box>
              </Box>
            )}
          />
        )}
    </Box>
  );
}
